exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.buttonNoHoverBackground .v-btn:before {\n    background-color: transparent;\n    transition: none;\n}\n.buttonNoHoverBackground .v-btn:after {\n    background-color: transparent;\n    transition: none;\n}\n\n", ""]);
